





























































import { Component, Vue } from 'vue-property-decorator';
import Api from '@/api/Api';

@Component
export default class SendMissionCode extends Vue {
  $refs: any

  $toast: any

  private fullname: string = ''

  private email: string = ''

  private driverPhoneNumber: string | null = null

  private registrationNumber: string = ''

  private model: string = ''

  private company: number = 0

  private numMissionBca: string = ''

  private driverPhoneNumberFormatted: string = ''

  private token: string = ''

  private formSubmitting: boolean = false

  private templateID: number = 3067

  private COMPANY = [
    { name: 'AVIVA', code: 'D57' },
    { name: 'Avanssur', code: '392' },
    { name: 'Aviva', code: '001' },
    { name: 'La Banque Postale', code: '694' },
    { name: 'Thelem', code: '150' },
    { name: 'Eurofil', code: '448' },
    { name: 'L’équité', code: '104' },
    { name: 'AMALINE', code: '665 / 865' },
    { name: 'Pacifica', code: '446' },
    { name: 'L’OLIVIER ASSURANCES AUTO', code: '699' },
    { name: 'AXA France', code: '799' },
    { name: 'SOGESSUR', code: '594' }];

  get isFormValid(): boolean {
    return (
      !!this.fullname
      && !!this.driverPhoneNumberFormatted
      && !!this.email
    );
  }

  getCodeAndNameFromList(num:number) {
    return this.COMPANY[num];
  }

  get fieldsBody() {
    const s = this.getCodeAndNameFromList(this.company);
    return {
      fields: [
        { value: this.fullname, section: 0, name: 'name_firstname' },
        { value: this.email, section: 0, name: 'email' },
        { value: this.driverPhoneNumberFormatted, section: 0, name: 'phone_number' },
        { value: this.registrationNumber, section: 1, name: 'register' },
        { value: this.model, section: 1, name: 'model' },
        { value: this.numMissionBca, section: 0, name: 'bcafilenumb' },
        { value: s.code, section: 0, name: 'code_societe_bca' },
        { value: s.name, section: 0, name: 'nom_soc_assurance_bca' },
      ],
    };
  }

  checkEmailFields() {
    return this.$refs.email.checkHtml5Validity();
  }

  missionBody(proovCode: string) {
    return {
      email: this.email,
      title: 'Declaration de sinistre',
      description: `${process.env.VUE_APP_BRAND} vous aide a déclarer votre sinistre`,
      report_state: 'pending_first',
      proov_code: proovCode,
      phone_number: this.driverPhoneNumberFormatted,
      body_sms: SendMissionCode.generateSms(proovCode),
      send_email: false,
      sender: 'BCA LEA',
    };
  }

  async sendCode(): Promise<void> {
    if (!this.isFormValid) {
      return;
    }
    try {
      this.formSubmitting = true;
      const res = await Api.initTemplate(
        this.token,
        this.templateID,
        JSON.stringify(this.fieldsBody),
      );
      const proovCode = res.data.proov_code;
      await Api.sendMission(
        this.token,
        JSON.stringify(this.missionBody(proovCode)),
      );
      this.$toast.open({
        message: `Mission envoyée. ProovCode : ${proovCode}`,
        type: 'is-success',
        position: 'is-bottom',
      });
    } catch (e) {
      console.log(e);
      this.$toast.open({
        message: 'Erreur d\'envoi',
        type: 'is-danger',
        position: 'is-bottom',
      });
    } finally {
      this.formSubmitting = false;
    }
  }

  async mounted() {
    const res = await Api.login(
      process.env.VUE_APP_TOKEN,
      process.env.VUE_APP_SECRET,
    );
    this.token = res.data.access_token;
  }

  static generateSms(proovCode: string) {
    let msg = `Vous avez eu un sinistre, ${process.env.VUE_APP_BRAND} vous accompagne :\n`;
    msg += `Cliquez ici pour télécharger l'application: ${process.env.VUE_APP_BRAND_APP_LINK}\n`;
    msg += `\nUtilisez le CODE MISSION suivant : ${proovCode}\n`;
    msg += '\nMerci pour votre confiance\n';
    msg += `Votre équipe ${process.env.VUE_APP_BRAND}`;
    return msg;
  }
}
